import { assessmentsHooks } from "pages/School/Assessments"
import { citiesOptions } from "keys/cities"
import { useQueryClient } from "@tanstack/react-query"
import qc from "keys/queryClient"

const useFilterItems = () => {
    let headerItems = assessmentsHooks.useHeaderItems()
    const queryClient = useQueryClient()

    const cities = queryClient.getQueryData([qc.cities])

    let customHeaderItems = [
        {
            id: 3,
            placeholder: "בחר עיר",
            options: cities,
            name: "cities",
            component: "autoComplete",
            labelKey: "label",
            multiple: true
        },
        {
            id: 4,
            placeholder: "בחר בית ספר",
            options: [],
            name: "affiliations",
            component: "autoComplete",
            multiple: true
        },
        {
            ...headerItems.grade_of_execution,
            placeholder: "בחר שכבת ביצוע",
        },
        {
            ...headerItems.category,
            placeholder: "בחר סוג מבדק",
        }
    ]

    return customHeaderItems
}

export default useFilterItems